import { memo } from "react";
import { FormattedMessage } from "react-intl";
import { ButtonLink } from "app/components/ui/ButtonLink/ButtonLink";
import "./ProductActionButtonMobile.scss";

const ProductActionButtonMobile = () => {
	return (
		<div className="product-action-button-mobile" data-testid="product-action-button-mobile">
			<ButtonLink
				variant="primary"
				size="lg"
				fullWidth
				to={{ pathname: "/booking/search" }}
				data-testid="check-availibility-mobile-cta"
			>
				<FormattedMessage id="product.page.button.cta" />
			</ButtonLink>
		</div>
	);
};

export default memo(ProductActionButtonMobile);
